/**
 * Fecha de negocio de Argentina (UTC-03) como "YYYY-MM-DD".
 *
 * Argentina no aplica horario de verano: restar 3 horas explícitamente y leer
 * los componentes UTC evita que la fecha dependa del timezone del proceso o de
 * la representación UTC (p. ej. `toISOString()`), que adelanta el día entre
 * las 21:00 y 23:59 locales. Es el equivalente frontend de
 * `claveFechaNegocio()` del controller de reparaciones de usados.
 *
 * @param {Date} [ahora] Instante de referencia (inyectable para pruebas).
 * @returns {string} Fecha de negocio en formato YYYY-MM-DD.
 */
export function fechaNegocioArgentina(ahora = new Date()) {
  const argentina = new Date(ahora.getTime() - 3 * 60 * 60 * 1000);
  const anio = argentina.getUTCFullYear();
  const mes = String(argentina.getUTCMonth() + 1).padStart(2, "0");
  const dia = String(argentina.getUTCDate()).padStart(2, "0");
  return `${anio}-${mes}-${dia}`;
}

/**
 * Hora de negocio de Argentina (UTC-03) como "HH:MM".
 *
 * Usa el mismo desplazamiento que `fechaNegocioArgentina()`: restar 3 horas y
 * leer los componentes UTC evita depender del timezone del proceso.
 *
 * @param {Date} [ahora] Instante de referencia (inyectable para pruebas).
 * @returns {string} Hora en formato HH:MM.
 */
export function horaNegocioArgentina(ahora = new Date()) {
  const argentina = new Date(ahora.getTime() - 3 * 60 * 60 * 1000);
  const horas = String(argentina.getUTCHours()).padStart(2, "0");
  const minutos = String(argentina.getUTCMinutes()).padStart(2, "0");
  return `${horas}:${minutos}`;
}